import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/solid/download-fill.svg'


const _hoisted_1 = { class: "-mt-10" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "linked-icon h-6 w-6",
  src: _imports_0,
  alt: "download icon"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

import { // languages
		useI18n
	} from 'vue-i18n'
	
	import { // store
		localesStore
	} from '@/store/locales'

	
	const __default__ = { name: 'DocumentDetails' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		attendee: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()

	const {t} = useI18n()

return (_ctx: any,_cache: any) => {
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tw_table, {
      placeholder: _unref(t)('placeholders.noDocuments'),
      loading: __props.loading,
      data: __props.attendee.portalData?.['attendees__DOCUMENTS__attendeesID']
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('202')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row["attendees__DOCUMENTS__attendeesID::name_display"]), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('190')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row["attendees__DOCUMENTS__attendeesID::description_display"]), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('445')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row["attendees__DOCUMENTS__attendeesID::stamp_create"]), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, null, {
          default: _withCtx(({row}) => [
            _createElementVNode("a", {
              target: "_blank",
              class: "cursor-pointer",
              href: row?.signedUrl,
              download: ""
            }, _hoisted_4, 8, _hoisted_2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["placeholder", "loading", "data"])
  ]))
}
}

})